// extracted by mini-css-extract-plugin
export default {"subtitle":"CallToAction-module--subtitle--hvQSA","title":"CallToAction-module--title--3o-ea"};